import * as actionTypes from './actionTypes';

export function changeLanguageAction(language) {
    return {
        type: actionTypes.CHANGE_LANGUAGE,
        language,
    };
}

export function refreshDataAction() {
    return {
        type: actionTypes.REFRESH_DATA,
    };
}

export function fetchNavOptionsAction() {
    return {
        type: actionTypes.FETCH_NAV_OPTIONS,
    };
}

export function setNavOptionsAction(navOptions) {
    return {
        type: actionTypes.SET_NAV_OPTIONS,
        navOptions,
    };
}

export function fetchUserLocaleAction() {
    return {
        type: actionTypes.FETCH_USER_LOCALE,
    };
}

export function setDropdownOpenAction(dropdownOpenId) {
    return {
        type: actionTypes.SET_DROPDOWN_OPEN,
        dropdownOpenId,
    };
}

export function setDropdownCloseAction() {
    return {
        type: actionTypes.SET_DROPDOWN_CLOSE,
    };
}

export function setLogoutUserAction() {
    return {
        type: actionTypes.LOGOUT_USER,
    };
}
